import * as React from 'react';

import {
    Container,
    Row,
    Col
} from 'reactstrap';

import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material';

import { FSModels } from '@finagraph/financial-statement-editor';

import { PortalTextFinancialStatements } from '../../../Models/Api/strongbox.financialportal';

type Props = {
    onUpdate: (newValue: FSModels.ReportingPeriodTypes) => void;
    reportingPeriod: FSModels.ReportingPeriodTypes | undefined;
    financialStatementsText?: PortalTextFinancialStatements;
}

export const FinancialStatementReportingPeriod: React.FC<Props> = (props): React.ReactElement => {
    const {
        onUpdate,
        reportingPeriod,
        financialStatementsText,
    } = props;

    return (
        <Container fluid>
            <Row>
                <Col>
                    <div className={'right-aligned-col'}>
                        <FormControl fullWidth>
                            <InputLabel id="reporting-period-select-label">{financialStatementsText?.reportingPeriod || ''}</InputLabel>
                            {reportingPeriod && (
                                <Select
                                    labelId={"reporting-period-select-label"}
                                    label={financialStatementsText?.reportingPeriod || ''}
                                    value={reportingPeriod}
                                    // @ts-ignore TS2345   this will have a correct value
                                    onChange={e => onUpdate(e.target.value)}
                                    MenuProps={{
                                        sx: {
                                            '& div': {
                                                borderRadius: 0
                                            }
                                        }
                                    }}
                                    sx={{ borderRadius: '0px' }}
                                >
                                    <MenuItem value={FSModels.ReportingPeriodTypes.FiscalYearsAndYTD}>{financialStatementsText?.periodFiscalYear || ''}</MenuItem>
                                    <MenuItem value={FSModels.ReportingPeriodTypes.FiscalQuartersAndQTD}>{financialStatementsText?.periodFiscalQuarter || ''}</MenuItem>
                                    <MenuItem value={FSModels.ReportingPeriodTypes.MonthsAndMTD}>{financialStatementsText?.periodMonths || ''}</MenuItem>
                                </Select>
                            )}
                        </FormControl>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}
